import { ContextMenu } from "@/components/ui";
import type { MatterTag } from "@/lib/types";
import type { ReactNode } from "react";

type MatterTagContextMenuProps = {
  canDelete: boolean;
  canEdit: boolean;
  onDelete: () => void;
  onEdit: () => void;
  tag: MatterTag;
  trigger: ReactNode;
};

export function MatterTagContextMenu({
  canDelete,
  canEdit,
  onDelete,
  onEdit,
  tag,
  trigger,
}: MatterTagContextMenuProps) {
  return (
    <ContextMenu
      entityName="matter tag"
      open={canEdit ? { onSelect: onEdit } : false}
      copy={{ successLabel: "Tag label", value: tag.label }}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    />
  );
}
